import { useEffect, useRef } from "react";
import { isMobile, scroll2Top } from "../utils/utils";
import InfoBeneficiaryStep1Bloc from "../blocs/info-beneficiary/InfoBeneficiaryStep1Bloc";

export default function InfoBeneficiaryStep1Page() {
  const pageGapRef = useRef<null | HTMLDivElement>(null);
  useEffect(() => {
    if (isMobile()) {
      pageGapRef.current?.scrollIntoView() 
    } else {
      scroll2Top();
    }
  }, []);

    return (
    
      <div className="entreprise-container">
        
        <h1 className="title ml-lg-desktop mb-sm">Les attestations de droits de mes proches</h1>
        <div ref={pageGapRef} className="page-gap" />
        <div className="page-content flex-grid m-lg-desktop">
            <InfoBeneficiaryStep1Bloc/>
        </div>
      </div>
   
    )

}